import React from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

type IconSize = 'small' | 'medium' | 'large';

export interface IconProps extends Omit<SvgIconProps, 'color' | 'fontSize'> {
  /**
   * @ignore
   * Classes applied to the root element.
   */
  className?: string;

  /**
   * The color of the Icon.
   */
  color?: string;

  /**
   * The size of the Icon.
   * small:   12px x 12px
   * medium:  16px x 16px
   * large:   24px x 24px
   * @default medium
   */
  size?: IconSize;
}

const sizeToFontSize: Record<IconSize, number> = {
  small: 12,
  medium: 16,
  large: 24,
};

export default function createSvgIcon(svg: any, displayName: string) {
  function Component(
    { className, color, size = 'medium', ...rest }: IconProps,
    ref: React.ForwardedRef<SVGSVGElement>,
  ) {
    return (
      <SvgIcon
        ref={ref}
        className={className as any}
        sx={{ color, fill: 'transparent', fontSize: sizeToFontSize[size] }}
        component={svg}
        strokeWidth={1}
        {...rest}
      />
    );
  }

  const ForwardedComponent = React.forwardRef(Component);
  const MemoizedComponent = React.memo(ForwardedComponent as any);
  MemoizedComponent.displayName = displayName;

  return MemoizedComponent;
}
